<script>
  import { pages, currentPageIndex, ci, overlay, useGlobalFloatingIcon } from "./store.js";

  import OverlayCircleModal from "./helpers/OverlayCircleModal.svelte";
  import OverlayCircle from "./helpers/OverlayCircle.svelte";
  import Modal from "svelte-simple-modal";
  import Drawer from 'svelte-drawer-component'
  import Image from "./widgets/Image.svelte"

  $: page = pages[$currentPageIndex];

  let mainMaxWidth = $ci.page.body.max_width ?? "60vw";

  let drawerOpen = false;
</script>

<div class="locked-overlay" style="--main-width: {mainMaxWidth}">
  <div class="side">
    <div class="characters">
      {#each overlay.left as item}
        <Modal>
          <OverlayCircleModal
            picture={item.picture}
            youtube_id={item.youtube_id}
          />
        </Modal>
      {/each}
    </div>
  </div>
  <div class="overlay-dummy-body">&nbsp;</div>
  <div class="side">
    <div class="options">
      {#each overlay.right as item}
        <Modal>
          <OverlayCircleModal picture={item.picture} link={item.link} />
        </Modal>
      {/each}
    </div>

    {#if useGlobalFloatingIcon}
      <div class="locked-drawer-pull-tab" on:click="{() => drawerOpen = true}"><img src="assets/icons/map.png"></div>
      <Drawer open={drawerOpen} placement='top' on:clickAway={() => drawerOpen=false} size="100%">
          <!--<button on:click={() => drawerOpen = false}>Close</button>-->
          <div class="drawer-content">
            <Image source="assets/images/karte.png" alt="Karte" zoomable="true" />
            <div on:click={() => drawerOpen = false} class="drawer-close"><span>&times;</span></div>
            <a target="_blank" href="assets/images/karte.png">Karte in neuem Tab öffnen</a>
          </div>
      </Drawer>
    {/if}
  </div>
</div>

<style type="text/scss">
  .locked-drawer-pull-tab {
    --pullout-height: 10px;

    position: absolute;
    top: calc(var(--pullout-height) * -1);
    max-width: 50px;
    height: calc(50px + var(--pullout-height));
    background: #faf5e7;
    border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em;
    transition: all 0.1s ease-in-out;
    cursor: pointer;

    & img {
      box-sizing: border-box;
      width: 100%;
      margin-top: var(--pullout-height);
      padding: 0.5em;
    }

    &:hover {
      top: 0px;
    }
  }

  .drawer-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;

    a {
      position: fixed;
      top: 0;
      left: 0;
      margin: 1em;
      color: black;
      background: rgba(255, 255, 255, 0.5);
      padding: 0.4em;
      border-radius: 2px;
    }
  }

  :global(.drawer-content img, .drawer-content .locked-img-container) {
    object-fit: contain;
    min-height: 100% !important;
    width: auto !important;
  }

  .drawer-close {
    position: fixed;
    top: 0;
    right: 0;
    margin: 0.5em;
    background: rgba(255, 255, 255, 0.5);
    cursor: pointer;
    font-size: 2em;
    color: black;
    border-radius: 50%;
    aspect-ratio: 1 / 1;
    line-height: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      padding: 0.15em;
      margin-bottom: 6px;
    }

  }

  :global(.drawer) {
    pointer-events: none;
  }

  :global(.drawer .overlay) {
        background: rgba(0, 0, 0, 0.5);
        pointer-events: none;
    }

  :global(.drawer.open) {
      z-index: 1100 !important;
  }

  :global(.drawer.open .overlay) {
      pointer-events: auto;
  }


  :global(.drawer .panel) {
      background: #faf5e7;
      color: white;
      pointer-events: auto;
  }

  .locked-overlay {
    position: fixed;
    /*top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    width: 50px;*/

    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;

    z-index: 100;

    pointer-events: none;

    .side {
      display: flex;
      flex-direction: column-reverse;
      pointer-events: auto;
    }

    .overlay-dummy-body {
      width: var(--main-width);
      pointer-events: none;
      flex: 0 0 auto;
      margin: 0 1em;
    }

    .characters,
    .options {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-end;
    }
  }
</style>
